
export type LowerPaneDetailsBuilder<T> = (row: T) => [string, string][];

export type DetailsBuilderRow<T, K extends keyof T> = {
    data: K;
    caption: string;
    render?: (value: T[K], row: T) => string | undefined;
    skip?: (value: T[K], row: T) => boolean;
};

export type DetailsBuilderIndexedRow<T> = { [K in keyof T]-?: DetailsBuilderRow<T, K> }[keyof T];

export type DetailsBuilderTable<T> = DetailsBuilderIndexedRow<T>[];

export function useDefaultDetailsBuilder<T>(table: DetailsBuilderTable<T>): LowerPaneDetailsBuilder<T> {
    return function(row: T) {
        return table.filter((builder) => !builder.skip?.(row[builder.data], row)).map((builder) => {
            let value: string;
            if(builder.render) {
                value = builder.render(row[builder.data], row) ?? '';
            } else {
                value = String(row[builder.data] ?? '');
            }
            return [builder.caption, value];
        });
    };
}
